/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { LastRechtGruppeEntryMeta } from './lastRechtGruppeEntryMeta';
import { HistInfoMeta } from './histInfoMeta';
import { RechteIdMeta } from './rechteIdMeta';
import { StandardRechtBeteiligungMasterDetailEntryMeta } from './standardRechtBeteiligungMasterDetailEntryMeta';
import { GrundstueckListEntryMeta } from './grundstueckListEntryMeta';
import { StandardrechtMasterId } from './standardrechtMasterId';
import { RechtMasterListEntryMeta } from './rechtMasterListEntryMeta';
import { StandardrechtVersionDetailEntryMeta } from './standardrechtVersionDetailEntryMeta';


export interface StandardrechtMasterDetailEntryMeta { 
    rechteId?: RechteIdMeta;
    mRechteId?: FieldMetaData;
    ereid?: string;
    mEreid?: FieldMetaData;
    bereinigungsGrund?: string;
    mBereinigungsGrund?: FieldMetaData;
    rechtArt?: StandardrechtMasterDetailEntryMeta.RechtArtEnum;
    mRechtArt?: FieldMetaData;
    dokulinkVerfuegbar?: StandardrechtMasterDetailEntryMeta.DokulinkVerfuegbarEnum;
    mDokulinkVerfuegbar?: FieldMetaData;
    isSdrDienstbarkeit?: boolean;
    mIsSdrDienstbarkeit?: FieldMetaData;
    perimeter?: Array<GrundstueckListEntryMeta>;
    mPerimeter?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    servitutenregisterNr?: string;
    mServitutenregisterNr?: FieldMetaData;
    bereinigungsMarkierung?: boolean;
    mBereinigungsMarkierung?: FieldMetaData;
    isNavigierbar?: boolean;
    mIsNavigierbar?: FieldMetaData;
    beteiligungMasters?: Array<StandardRechtBeteiligungMasterDetailEntryMeta>;
    mBeteiligungMasters?: FieldMetaData;
    ursprung?: RechtMasterListEntryMeta;
    mUrsprung?: FieldMetaData;
    lastRechtGruppen?: Array<LastRechtGruppeEntryMeta>;
    mLastRechtGruppen?: FieldMetaData;
    versions?: Array<StandardrechtVersionDetailEntryMeta>;
    mVersions?: FieldMetaData;
    id?: StandardrechtMasterId;
    mId?: FieldMetaData;
}
export namespace StandardrechtMasterDetailEntryMeta {
    export type RechtArtEnum = 'DIENSTBARKEIT' | 'VORMERKUNG' | 'ANMERKUNG' | 'GRUNDLAST' | 'PFANDRECHT' | 'SDR_DIENSTBARKEIT' | 'EIGENTUM_ANTEIL';
    export const RechtArtEnum = {
        DIENSTBARKEIT: 'DIENSTBARKEIT' as RechtArtEnum,
        VORMERKUNG: 'VORMERKUNG' as RechtArtEnum,
        ANMERKUNG: 'ANMERKUNG' as RechtArtEnum,
        GRUNDLAST: 'GRUNDLAST' as RechtArtEnum,
        PFANDRECHT: 'PFANDRECHT' as RechtArtEnum,
        SDRDIENSTBARKEIT: 'SDR_DIENSTBARKEIT' as RechtArtEnum,
        EIGENTUMANTEIL: 'EIGENTUM_ANTEIL' as RechtArtEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        NICHTVORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
}


